import { render, staticRenderFns } from "./ServiceOrders.vue?vue&type=template&id=19d71d30"
import script from "./ServiceOrders.vue?vue&type=script&lang=js"
export * from "./ServiceOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports